function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeToggleButtonStyles = function makeToggleButtonStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.typography["body-copy-small"]), {}, {
          color: tokens.colors["ink-on-background-60"],
          fontWeight: primitives.fontWeights.stout,
          padding: "4.5px ".concat(primitives.spacings["4"]),
          border: "none",
          boxSizing: "border-box",
          "&:hover": {
            backgroundColor: tokens.colors["hover-fill-subtle"]
          },
          "&:active": {
            backgroundColor: tokens.colors["pressed-fill-subtle"],
            border: "none"
          },
          "&.Mui-selected": {
            backgroundColor: tokens.colors["fill-elevation-2"],
            color: tokens.colors["ink-on-background"],
            "&:hover": {
              backgroundColor: tokens.colors["fill-elevation-2"]
            }
          },
          "&.Mui-disabled": {
            border: "none",
            color: tokens.colors["detail-1-transparent"]
          }
        }),
        sizeSmall: {
          fontSize: primitives.fontSizes["1"],
          padding: "3px ".concat(primitives.spacings["3"])
        }
      }
    }
  };
};